import { FORM_TYPE } from "../../constants/custom-define-type";
import { TEXTBOX_INPUT_TYPE } from "../../constants/custom-define-type";

const educationLevel = [
  "High School Diploma",
  "Associates Degree",
  "Bachelor’s Degree",
  "Some College Courses",
  "Master’s Degree",
  "PHD"
];

const positions = [
  "Full Time Nanny",
  "Part Time Nanny",
  "Private Educator",
  "Occasional work",
  "Summer Position",
  "NCS"
];

const candidateSkills = ["skill 1", "skill 2", "skill 3"];

const availabilityOptions = ["Live In", "Live Out", "Both"];

const americanStates = [
  "AL",
  "AK",
  "AS",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FM",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MH",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "MP",
  "OH",
  "OK",
  "OR",
  "PW",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VI",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

const professionalInfoFields = [
  {
    type: FORM_TYPE.RADIO,
    label: "Do you have Skype or Facetime? *",
    model: "boolean_selector1"
  },
  {
    label: "What is your Skype or Facetime information? *",
    model: "text1",
    showIf: "boolean_selector1"
  },
  {
    label: "Emergency Contact",
    model: "selector1",
    isRequired: false
  },
  {
    type: FORM_TYPE.RADIO,
    label: "Are you Legally Authorized to work in the USA? *",
    labelDetail: "Am I Legally Authorized to work in the USA?",
    model: "boolean_selector2"
  },
  {
    type: FORM_TYPE.RADIO,
    label: "Are you currently CPR Certified? *",
    labelDetail: "Am I currently CPR Certified?",
    model: "boolean_selector3"
  },
  {
    type: FORM_TYPE.RADIO,
    label:
      "Are you able to give a one-year commitment to the childcare service you will provide? *",
    labelDetail:
      "Am I able to give a one-year commitment to the childcare service I will provide?",
    model: "boolean_selector4"
  },
  {
    type: FORM_TYPE.RADIO,
    label: "Are you a smoker? *",
    labelDetail: "Am I a smoker?",
    model: "boolean_selector5"
  },
  {
    label:
      "Do you speak any languages other than English fluently? (Please list all the languages that you speak fluently.) *",
    labelDetail: "Am I speak any languages other than English fluently?",
    model: "selector2"
  },
  {
    type: FORM_TYPE.CHECKBOX,
    optionList: educationLevel,
    label:
      "Let's talk education. What's have you completed? (Check all that apply) *",
    labelDetail: "Let's talk education. What's have I completed?",
    model: "multiselect1"
  },
  {
    type: FORM_TYPE.CHECKBOX,
    optionList: positions,
    label: "Position you are applying for (check all that apply) *",
    labelDetail: "Position I are applying for",
    model: "multiselect2"
  },
  {
    type: FORM_TYPE.RADIO,
    optionList: availabilityOptions,
    label: "Are you looking for a Live-in Position or Live-out Position? *",
    labelDetail: "Am I looking for a Live-in Position or Live-out Position?",
    model: "selector3"
  },
  {
    label: "Can we call you for Temp or Babysitting positions? *",
    labelDetail: "Can I be called for Temp or Babysitting positions?",
    model: "selector4"
  },
  // {
  //   type: FORM_TYPE.CHECKBOX,
  //   optionList: candidateSkills,
  //   label: "Skills? (check all that apply) *",
  //   labelDetail: "Skills?",
  //   model: "multiselect3"
  // },
  {
    label: "Please list your skills *",
    labelDetail: "Skills",
    model: "text6"
  },
  {
    label: "Days Available to Work? *",
    labelDetail: "Days Available to Work?",
    model: "text2"
  },
  {
    label: "Are you open to working on the weekend? *",
    labelDetail: "Am I open to working on the weekend?",
    model: "selector5"
  },
  {
    label: "Can you swim? Are you a strong swimmer? *",
    labelDetail: "Can I swim? Am I a strong swimmer?",
    model: "selector6"
  },
  {
    type: FORM_TYPE.RADIO,
    label: "Can you drive? *",
    labelDetail: "Can I drive?",
    model: "boolean_selector6"
  },
  {
    label: "Do you have a clean driving record? *",
    labelDetail: "Do I have a clean driving record?",
    model: "selector7"
  },
  {
    label: "Do you have your own car? *",
    labelDetail: "Do I have my own car?",
    model: "selector8"
  },
  {
    type: FORM_TYPE.RADIO,
    label: "Do you have experience with children with special needs? *",
    labelDetail: "Do I have experience with children with special needs?",
    model: "boolean_selector7"
  },
  {
    type: FORM_TYPE.TEXTAREA,
    label: "Explain? *",
    labelDetail: "Explain?",
    model: "text3",
    showIf: "boolean_selector7"
  },
  {
    label: "Do you have newborn experience? *",
    labelDetail: "Do I have newborn experience?",
    model: "selector9"
  },
  {
    label: "Any allergies? *",
    labelDetail: "Any allergies?",
    model: "selector10"
  },
  {
    label: "Can you work in a home with pets? *",
    labelDetail: "Can I work in a home with pets?",
    model: "selector11"
  },
  {
    type: FORM_TYPE.RADIO,
    label: "Are you willing to travel? (Do not say yes, if you cannot.) *",
    labelDetail: "Am I willing to travel?",
    model: "boolean_selector8"
  },
  {
    label: "Desired hourly rates? What is your target pay? *",
    labelDetail: "Desired hourly rates? What is my target pay?",
    model: "selector12"
  },
  {
    type: FORM_TYPE.TEXTAREA,
    label: "Have you received the COVID vaccine? If you have, when did you receive it, and which vaccine did you receive (ie. Pfizer, Moderna, Johnson & Johnson)? If not, are you scheduled to receive it (if so, when)? *",
    rows: 3,
    model: "text7"
  },
  {
    type: FORM_TYPE.TEXTAREA,
    label: "Tell us about yourself. *",
    rows: 5,
    model: "text4"
  },
];

const state = {
  experienceOptions: ["2-5 years", "5-10 years", "10 plus years"],
  commitmentOptions: [
    "Long Term (longer than 1 year)",
    "Short Term (1 year or less)",
    "Temporary"
  ],
  availabilityOptions: availabilityOptions,
  drvingStatuses: ["D.L. and Car", "Driver's License only", "Neither"],
  certificationStatuses: ["Yes", "Willing to get certified", "No"],
  vaccinationStatuses: ["Yes", "Willing to get", "No"],
  petsOptions: ["Dog", "Cat", "Neither"],
  travelOptions: ["Domestic", "International", "No travel"],
  candidateStatuses: [
    "Pre Application",
    "Applied",
    "Rejected",
    "Phone Screen Complete",
    "Interview Booked",
    "Interview Complete",
    // "Waiting on Agency Resume",
    // "Agency Resume Complete",
    "Profile Pending Review",
    "Documentation Complete",
    "Reference Check Complete",
    "Accepted",
    // "Temp Care",
    "Trialing",
    "Offer",
    // "Background Check Complete",
    "Inactive",
    "Hired"
  ],
  candidateActiveStatus: "Accepted",
  candidateSkills: candidateSkills,
  positions: positions,
  professionalInfoFields: professionalInfoFields,
  candidatePersonalInfoListFields: [
    {
      label: "First Name *",
      itemPerRow: 2,
      model: "first_name"
    },
    {
      label: "Last Name *",
      itemPerRow: 2,
      model: "last_name"
    },
    {
      label: "Street Address *",
      model: "address1"
    },
    {
      label: "City *",
      itemPerRow: 3,
      model: "city"
    },
    // {
    //   label: "State *",
    //   itemPerRow: 3,
    //   model: "provincestate"
    // },
    {
      label: "State *",
      model: "provincestate",
      type: FORM_TYPE.DROPDOWN,
      optionList: americanStates,
      itemPerRow: 3,
      // isRequired: false
    },
    {
      label: "Zip code *",
      itemPerRow: 3,
      maxLength: 12,
      inputType: TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER,
      model: "postal_code"
    },
    {
      label: "Home Number *",
      itemPerRow: 2,
      model: "phone"
    },
    {
      label: "Cell phone *",
      itemPerRow: 2,
      model: "phone2"
    },
    {
      label: "Email *",
      model: "email",
      validation: [
        {
          regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          message: "Please enter a valid email."
        }
      ],
    },
    // {
    //   type: FORM_TYPE.RADIO,
    //   label: "Do you have Skype or Facetime? *",
    //   model: "boolean_selector1"
    // },
    // {
    //   label: "What is your Skype or Facetime information? *",
    //   model: "text1",
    //   showIf: "boolean_selector1"
    // },
    // {
    //   label: "Emergency Contact",
    //   model: "selector1",
    //   isRequired: false
    // },
    ...professionalInfoFields,
    // {
    //   type: FORM_TYPE.TEXTAREA,
    //   label: "Tell us about yourself. *",
    //   rows: 5,
    //   model: "text4"
    // }
  ],
  referenceListFields: [
    {
      label: "Professional Reference Names? *",
      model: "name"
    },
    {
      label: "Location *",
      model: "text1"
    },
    {
      label: "Best Number to Contact Reference? *",
      model: "phone"
    },
    {
      label: "Best Email",
      model: "email",
      isRequired: false,
      validation: [
        {
          regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
          message: "Please enter a valid email."
        }
      ]
    },
    {
      label: "Best time to contact *",
      model: "text2"
    },
    {
      label: "Dates of employment? *",
      model: "text3"
    },
    {
      label: "Number of children under your care? *",
      labelDetail: "Number of children under my care?",
      model: "selector1",
      inputType: TEXTBOX_INPUT_TYPE.POSITIVE_INTEGER
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "What were your responsibilities? *",
      labelDetail: "What were my responsibilities?",
      model: "text4"
    },
    {
      type: FORM_TYPE.TEXTAREA,
      label: "Reason/s for Leaving? *",
      model: "text5"
    }
  ]
};

const mutations = {};

const actions = {};

const getters = {
  experienceOptions(state) {
    return state.experienceOptions;
  },
  commitmentOptions(state) {
    return state.commitmentOptions;
  },
  availabilityOptions(state) {
    return state.availabilityOptions;
  },
  drvingStatuses(state) {
    return state.drvingStatuses;
  },
  certificationStatuses(state) {
    return state.certificationStatuses;
  },
  vaccinationStatuses(state) {
    return state.vaccinationStatuses;
  },
  petsOptions(state) {
    return state.petsOptions;
  },
  travelOptions(state) {
    return state.travelOptions;
  },
  candidateStatuses(state) {
    return state.candidateStatuses;
  },
  candidateActiveStatus(state) {
    return state.candidateActiveStatus;
  },
  candidateSkills(state) {
    return state.candidateSkills;
  },
  professionalInfoFields(state) {
    return state.professionalInfoFields;
  },
  candidatePersonalInfoListFields(state) {
    return state.candidatePersonalInfoListFields;
  },
  referenceListFields(state) {
    return state.referenceListFields;
  },
  positions(state) {
    return state.positions;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/candidates.js